"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverDefaults = void 0;
const server_options_1 = require("./server-options");
exports.serverDefaults = {
    server: server_options_1.ServerOptions
};
//# sourceMappingURL=server-defaults.js.map